import React, { useEffect } from 'react';
import {
    Paper,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import axios from 'src/utils/axios';
import { makeStyles } from '@material-ui/core';
import Skeleton from '@mui/material/Skeleton';
import moment from 'moment';

const useStyles = makeStyles({
    tableHead: {
        fontWeight: 'bold',
        borderLeft: '1px solid #ddd',
    },
    tableRow: {
        borderLeft: '1px solid #ddd',
    }
});

function DetailsOfExchangeReceipt(props) {

    const classes = useStyles();
    const { ReceiptNumber } = props;

    const [productExchangeData, setProductExchangeData] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    useEffect(() => {
        getReceiptExchangeInformation();
    }, [])

    const getReceiptExchangeInformation = () => {
        axios.get(`GetReceiptExchangeInformation/${ReceiptNumber}`)
            .then((response) => {
                var exchangeData = response.data[0];
                setProductExchangeData(exchangeData ? exchangeData : []);
            }).catch((error) => {
                setLoading(false);
            });
    }

    return (
        <>
            {
                productExchangeData.length > 0 ?
                    (
                        <Paper elevation={3} style={{ marginBottom: 20, marginTop: 20 }}>
                            <TableContainer component={Paper}>
                                <Table size='small'>
                                    <TableHead>
                                        <TableRow style={{ backgroundColor: '#0033a0', color: '#fff' }}>
                                            <TableCell colSpan={8}>
                                                <Typography variant="h5" align="center" style={{ color: '#fff' }}>
                                                    Ürün Değişim
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {loading ? (
                                            Array.from(new Array(7)).map((_, index) => (
                                                <TableRow key={index}>
                                                    {Array.from(new Array(6)).map((_, cellIndex) => (
                                                        <TableCell key={cellIndex} colSpan={1}>
                                                            <Skeleton animation="pulse" variant="text" width={150} />
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            ))
                                        ) : (
                                            <>
                                                <TableRow>
                                                    <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Durumu:</TableCell>
                                                    <TableCell className={classes.tableRow}>{productExchangeData.Durum ? productExchangeData.Durum : '-'}</TableCell>
                                                    <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Değişim Türü</TableCell>
                                                    <TableCell colSpan={2} className={classes.tableRow}>{productExchangeData.DEGISIM_TURU ? productExchangeData.DEGISIM_TURU : '-'}</TableCell>
                                                    <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Müşteri Tipi:</TableCell>
                                                    <TableCell className={classes.tableRow}>{productExchangeData.MUSTERI_TIPI_ACIKLAMA ? productExchangeData.MUSTERI_TIPI_ACIKLAMA : '-'}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Durum Tarihi:</TableCell>
                                                    <TableCell className={classes.tableRow}>{productExchangeData.STATUSDATE ? moment(productExchangeData.STATUSDATE).format('DD/MM/YYYY HH:mm:ss') : '-'}</TableCell>
                                                    <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Onay Tipi:</TableCell>
                                                    <TableCell colSpan={2} className={classes.tableRow}>{productExchangeData.OnayTipi ? productExchangeData.OnayTipi : '-'}</TableCell>
                                                    <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Onaylayan:</TableCell>
                                                    <TableCell className={classes.tableRow}>{productExchangeData.ONAYLAYAN ? productExchangeData.ONAYLAYAN : '-'}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Değişim Nedeni:</TableCell>
                                                    <TableCell colSpan={6} className={classes.tableRow}>{productExchangeData.DEGISIM_NEDENI ? productExchangeData.DEGISIM_NEDENI : '-'}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>GPSNO:</TableCell>
                                                    <TableCell className={classes.tableRow}>{productExchangeData.TUTAR ? productExchangeData.GPSNO : '-'}</TableCell>
                                                    <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Revizyonlu:</TableCell>
                                                    <TableCell colSpan={2} className={classes.tableRow}>{productExchangeData.REVIZYONLU ? productExchangeData.REVIZYONLU : '-'}</TableCell>
                                                    <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Referans ID:</TableCell>
                                                    <TableCell className={classes.tableRow}>{'-'}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Tutar:</TableCell>
                                                    <TableCell className={classes.tableRow}>{productExchangeData.TUTAR ? productExchangeData.TUTAR : '-'}</TableCell>
                                                    <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Teminsiz Stok:</TableCell>
                                                    <TableCell colSpan={2} className={classes.tableRow}>{productExchangeData.TEMINSIZSTOK ? productExchangeData.TEMINSIZSTOK : '-'}</TableCell>
                                                    <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Fatura Yılı:</TableCell>
                                                    <TableCell className={classes.tableRow}>{productExchangeData.FAT_YIL ? productExchangeData.FAT_YIL : '-'}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Verilen Stok:</TableCell>
                                                    <TableCell className={classes.tableRow}>{productExchangeData.VERILENSTOKNO ? productExchangeData.VERILENSTOKNO : '-'}</TableCell>
                                                    <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Ürün Açıklama:</TableCell>
                                                    <TableCell colSpan={2} className={classes.tableRow}>{productExchangeData.VERILENURUNACK ? productExchangeData.VERILENURUNACK : '-'}</TableCell>
                                                    <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Fatura Dönemi:</TableCell>
                                                    <TableCell className={classes.tableRow}>{productExchangeData.FAT_DONEM ? productExchangeData.FAT_DONEM : '-'}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Bölge Yöneticiliği Mesajı:</TableCell>
                                                    <TableCell colSpan={6} className={classes.tableRow}>{productExchangeData.BOLGE_EKLENTI ? productExchangeData.BOLGE_EKLENTI : '-'}</TableCell>
                                                </TableRow>
                                            </>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    )
                    :
                    null
            }
        </>
    )
}

export default DetailsOfExchangeReceipt